/** Geographic markets as the case files record them ("United Arab Emirates", "Dubai and Sharjah"), in the reader's language. */
const PLACES: Record<string, string> = {
  "United Arab Emirates": "دولة الإمارات العربية المتحدة",
  UAE: "دولة الإمارات العربية المتحدة",
  "Abu Dhabi": "أبوظبي",
  Dubai: "دبي",
  Sharjah: "الشارقة",
  Ajman: "عجمان",
  "Umm Al Quwain": "أم القيوين",
  "Ras Al Khaimah": "رأس الخيمة",
  Fujairah: "الفجيرة",
  "Northern Emirates": "الإمارات الشمالية",
  "Al Ain": "العين",
  RAK: "رأس الخيمة",
  UAQ: "أم القيوين",
  "Abu Dhabi emirate": "إمارة أبوظبي",
  "Sharjah emirate": "إمارة الشارقة",
  "Emirate of Sharjah": "إمارة الشارقة",
  "East coast of the UAE": "الساحل الشرقي لدولة الإمارات",
  "Abu Dhabi and Dubai ports hinterland": "الظهير البري لموانئ أبوظبي ودبي",
  GCC: "دول مجلس التعاون الخليجي",
  "Gulf Cooperation Council": "دول مجلس التعاون الخليجي",
  "Middle East": "الشرق الأوسط",
  "Sharjah City Centre": "سيتي سنتر الشارقة",
  "Mega Mall": "ميغا مول",
  MENA: "الشرق الأوسط وشمال أفريقيا",
  national: "على مستوى الدولة",
  National: "على مستوى الدولة",
  local: "محلي",
  Local: "محلي",
  "UAE-wide": "على مستوى الدولة",
  Federal: "اتحادي",
  Emirate: "محلي",
  Global: "عالمي",
  global: "عالمي",
  Worldwide: "عالمي",
};
const KEYS = Object.keys(PLACES).sort((a, b) => b.length - a.length);
/** Jurisdictions recorded as ISO country codes on party records; matched only as the whole value. */
const COUNTRIES: Record<string, string> = {
  AE: "الإمارات", SA: "السعودية", BH: "البحرين", KW: "الكويت", OM: "عمان", QA: "قطر", EG: "مصر", JO: "الأردن", IN: "الهند", CN: "الصين",
  GB: "المملكة المتحدة", UK: "المملكة المتحدة", US: "الولايات المتحدة", FR: "فرنسا", DE: "ألمانيا", NL: "هولندا", CH: "سويسرا", SG: "سنغافورة", JP: "اليابان", KR: "كوريا الجنوبية", TR: "تركيا",
};

export function geographyText(value: string | null | undefined, locale: string): string {
  if (!value) return "";
  if (!locale.startsWith("ar")) return value;
  const whole = PLACES[value.trim()] ?? COUNTRIES[value.trim()];
  if (whole) return whole;
  let s = value;
  for (const key of KEYS) s = s.replace(new RegExp(`\\b${key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "g"), PLACES[key]);
  // "and" joins two places once both are in Arabic ("Dubai and Sharjah"); inside a name still in English it stays a word of the name.
  return s.replace(/(?<=[\u0600-\u06FF)])\s+and\s+(?=[\u0600-\u06FF(])/g, " و").replace(/,\s*/g, "، ").replace(/\(\s*/g, "(").replace(/\s*\)/g, ")");
}

/**
 * A market as the data bank records it, in the reader's language. The Arabic name is stored as "product – geography"; its product
 * half is used when it is written in Arabic, and the geography always comes from the recorded geographic dimension.
 */
export function marketText(m: { nameAr?: string | null; productDimension: string; geographicDimension: string }, locale: string): { product: string; geography: string } {
  if (!locale.startsWith("ar")) return { product: m.productDimension, geography: m.geographicDimension };
  const head = (m.nameAr ?? "").split(" – ")[0]?.trim() ?? "";
  return { product: /[\u0600-\u06FF]/.test(head) ? head : m.productDimension, geography: geographyText(m.geographicDimension, locale) };
}
